// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__2VgbW","savePackageButton":"ClientWallet_savePackageButton__mCZSo"};